import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { BEGIN, FAILED, SUCCESSFUL } from '../../configs/actionNames';
import { VEHICLES_REGISTRY_MODULE } from '../../configs/moduleNames';

export const LOAD_VEHICLE_REGISTRY_LIST = '_LOAD_VEHICLE_REGISTRY_LIST';
export const LOAD_VEHICLE_REGISTRY_ON_MAP_LIST = '_LOAD_VEHICLE_REGISTRY_ON_MAP_LIST';
export const LOAD_VEHICLE_REGISTRY_BY_ID = '_LOAD_VEHICLE_REGISTRY_BY_ID';
export const LOAD_VEHICLE_REGISTRY_STATUS_HISTORY = '_LOAD_VEHICLE_REGISTRY_STATUS_HISTORY';
export const MAP_EVENT = '_MAP_EVENT';
export const LOAD_VEHICLE_TRIPS = '_LOAD_VEHICLE_TRIPS';

export const loadVehicleRegistryList = createDeferredAction(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_LIST);
export const loadVehicleRegistryListSuccessful = createAction(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_LIST + SUCCESSFUL);
export const loadVehicleRegistryListFailed = createAction(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_LIST + FAILED);
export const loadVehicleRegistryListBegin = createAction(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_LIST + BEGIN);

export const loadVehicleRegistryById = createDeferredAction(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_BY_ID);
export const loadVehicleRegistryByIdSuccessful = createAction(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_BY_ID + SUCCESSFUL);
export const loadVehicleRegistryByIdFailed = createAction(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_BY_ID + FAILED);

export const loadVehicleRegistryStatusHistory = createDeferredAction(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_STATUS_HISTORY);
export const loadVehicleRegistryStatusHistorySuccessful = createAction(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_STATUS_HISTORY + SUCCESSFUL);
export const loadVehicleRegistryStatusHistoryFailed = createAction(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_STATUS_HISTORY + FAILED);

export const loadVehicleTrips = createDeferredAction(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_TRIPS);
export const loadVehicleTripsSuccessful = createAction(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_TRIPS + SUCCESSFUL);
export const loadVehicleTripsFailed = createAction(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_TRIPS + FAILED);
